export const clearSessionStorage = (item: `travelQuote${string}`) => {
  sessionStorage.removeItem(item);
};
export const clearPISessionStorage = (item: string) => {
  sessionStorage.removeItem(item);
};
export const clearEventPLSessionStorage = (item: string) => {
  sessionStorage.removeItem(item);
};
